import { render, staticRenderFns } from "./UserAward.vue?vue&type=template&id=e9a82b36&scoped=true&"
import script from "./UserAward.vue?vue&type=script&lang=js&"
export * from "./UserAward.vue?vue&type=script&lang=js&"
import style0 from "./UserAward.vue?vue&type=style&index=0&id=e9a82b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a82b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9a82b36')) {
      api.createRecord('e9a82b36', component.options)
    } else {
      api.reload('e9a82b36', component.options)
    }
    module.hot.accept("./UserAward.vue?vue&type=template&id=e9a82b36&scoped=true&", function () {
      api.rerender('e9a82b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/StatisticsChildren/UserAward.vue"
export default component.exports